export enum UserRole {
    Normal = "Normal",
    Gallatin = "Gallatin"
}